import Component from '../inherited/Component'
import axios from 'axios'
import Helpers from '../lib/Helpers'

export default class ProductQuickAdd extends Component {
  constructor (elem, theme, options, ctx) {
    super(elem, theme, options, ctx)
    this._drawerElem = document.querySelector('[data-product-quick-add-drawer]')
    this._drawerContentElem = this._drawerElem.querySelector('[data-product-quick-add-drawer-content]')
    this._closeElems = this._drawerElem.querySelectorAll('[data-product-quick-add-close]')
    this._product = null
  }

  async mount () {
    this._elem.addEventListener('click', async e => {
      this._elem.classList.add('button--loading')

      let { data } = await axios.get(`/products/${this._options.handle}?view=quickadd`)
      let parser = new DOMParser()
      let html = parser.parseFromString(data, 'text/html')
      let fetchedElem = html.querySelector('[data-product-quick-add-content]')

      this._drawerContentElem.innerHTML = fetchedElem.innerHTML
      this._theme.mountComponents(this._drawerContentElem)
      
      this._drawerElem.classList.add('shown')
      this._elem.classList.remove('button--loading')
      this._productMount()
    })

    for (let elem of this._closeElems) {
      elem.addEventListener('click', e => {
        e.preventDefault()
        this._closeDrawer()
      })
    }

    this._drawerElem.addEventListener('click', e => {
      if (e.target === this._drawerElem) {
        this._closeDrawer()
      }
    })

    this._ctx.on('cart-item-added', async () => {
      this._closeDrawer()
    })
  }

  _closeDrawer () {
    this._drawerElem.classList.remove('shown')
  }

  _productMount () {
    let _variantOptionTriggers = this._drawerContentElem.querySelectorAll('[data-variant-option-trigger]')
    this._product = this._drawerElem.querySelector('[data-product-json]') ? JSON.parse(this._drawerElem.querySelector('[data-product-json]').innerHTML) : null

    for (let optionSelector of _variantOptionTriggers) {
      optionSelector.addEventListener('change', e => {
        this._onSelectChange()
      })
    }
  }

  _onSelectChange () {
    let variant = this._getVariantFromOptions()

    this._updateProductPrices(variant)
    this._updateAddToCartState(variant)
    if (!variant) {
      return
    }

    this._updateMasterSelect(variant)
  }

  _updateProductPrices (variant) {
    let productPrice = this._drawerContentElem.querySelector('[data-price]')
    productPrice.innerHTML = this._formatMoney(variant.price)
  }

  _formatMoney (price) {
    return Helpers.formatMoney(price, this._ctx.getState())
  }

  _updateAddToCartState (variant) {
    let addToCart = this._drawerContentElem.querySelector('[data-submit]')
    let _addToCartHTML = addToCart.innerHTML

    if (!variant && this._product.available) {
      addToCart.setAttribute('disabled', 'disabled')
      let addToCartText = addToCart.querySelector('[data-submit-text]') || addToCart
      addToCartText.innerHTML = this._ctx.getState().locale.makeASelection
      return
    }

    if (!variant) {
      return
    }

    if (variant.available) {
      addToCart.removeAttribute('disabled')
      let addToCartText = addToCart.querySelector('[data-submit-text]') || addToCart
      addToCartText.innerHTML = _addToCartHTML
    } else {
      addToCart.setAttribute('disabled', 'disabled')
      let addToCartText = addToCart.querySelector('[data-submit-text]') || addToCart
      addToCartText.innerHTML = this._ctx.getState().locale.soldOut
    }
  }

  _updateMasterSelect (variant) {
    let originalSelector = this._drawerContentElem.querySelector('[data-master-select]')
    originalSelector.value = variant.id
  }

  _getCurrentOptions () {
    let _variantOptionTriggers = this._drawerContentElem.querySelectorAll('[data-variant-option-trigger]')
    let currentOptions = []
    for (let optionSelector of _variantOptionTriggers) {
      let type = optionSelector.getAttribute('type')
      let currentOption = {}
      let alreadyDone = false
      for (let option of currentOptions) {
        if (option.index === optionSelector.dataset.index) {
          alreadyDone = true
        }
      }
      if (alreadyDone) continue
      if (type === 'radio' || type === 'checkbox') {
        if (optionSelector.checked) {
          currentOption.value = optionSelector.value
          currentOption.index = optionSelector.dataset.index
          currentOptions.push(currentOption)
        } else {
          currentOptions.push(false)
        }
      } else {
        currentOption.value = optionSelector.value
        currentOption.index = optionSelector.dataset.index
        currentOptions.push(currentOption)
      }
    }
    currentOptions = Helpers.compact(currentOptions)
    return currentOptions
  }

  _getVariantFromOptions () {
    let _variantRadios = this._drawerContentElem.querySelectorAll('[data-variant-id]')
    let selectedValues = this._getCurrentOptions()
    let variants = this._product.variants
    let found = false

    for (let radio of _variantRadios) {
      if (radio.checked) {
        return this._product.variants.find(variant => `${variant.id}` === radio.dataset.variantId)
      }
    }

    if (selectedValues.length > 0) {
      for (let variant of variants) {
        var satisfied = true

        for (let option of selectedValues) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index])
          }
        }

        if (satisfied) {
          found = variant
        }
      }
    }

    if (!found) {
      return this._product.variants.find(variant => `${variant.id}` === `${this._drawerContentElem.querySelector('[data-master-select]').value}`)
    }

    return found || null
  }
}